var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBandcamp = function SvgBandcamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Bandcamp",
    viewBox: "0 0 512 512"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff",
    rx: "15%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1ad",
    d: "M99 349h215l99-186H198"
  })));
};
export default SvgBandcamp;